import { useState } from 'react';
import useToast from '@/hooks/useToast';
import Toast from '@/components/base/Toast';

export default function SubscribeBox() {
  const [value, setValue] = useState('');
  const { message, show } = useToast();

  const handleRemind = () => {
    const trimmed = value.trim();
    if (!trimmed) {
      show('请先填写一个接收提醒的方式');
      return;
    }
    show('演示模式：更新提醒暂未接入，感谢体验');
    setValue('');
  };

  return (
    <section id="subscribe" className="bg-background-100 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="rounded-lg border border-foreground-950/12 bg-background-50 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center">
          <div>
            <p className="text-xs tracking-[0.25em] text-accent-700 font-label">NEWSLETTER · 更新提醒</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              有新站点和片单时提醒你
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 max-w-md">
              留下一个接收方式，当热度榜出现大变化、或深夜档上新时，我们会第一时间通知你。
            </p>
          </div>

          <div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="邮箱 / 微信号 / 手机号"
                className="flex-1 h-11 px-4 rounded-md border border-foreground-950/15 bg-background-100 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="button"
                onClick={handleRemind}
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer dark:text-foreground-950"
              >
                订阅提醒
              </button>
            </div>
            <p className="mt-3 text-xs text-foreground-500">
              本站为导航展示页，订阅功能仅为示意，不会收集或提交你的任何信息。
            </p>
          </div>
        </div>
      </div>
      <Toast message={message} />
    </section>
  );
}